export default __webpack_public_path__ + "static/life-grid-royal-blue-min-17d10849e843797579bbaf04d62cf1e7.png";